const account = {
  account: 'Account',
  changeProfilePicture: 'Change picture',
  createAnAccount: 'Create an Account',
  emailAddress: 'Email address',
  invalidConnection: 'Invalid connection',
  invalidOtp: 'Invalid or expired code',
  login: 'Log in',
  loginWithGoogle: 'Log in with Google',
  logout: 'Logout',
  noAccountFound: 'No account found for this email. Create an account first.',
  otpCode: 'One-time code',
  otpSent: 'A one-time code was sent to your email.',
  password: 'Password',
  profilePicture: 'Profile picture',
  profilePictureInvalidType: 'Please choose a JPEG, PNG, GIF, or WebP image.',
  profilePictureUploadFailed: 'Could not update the profile picture.',
  removeProfilePicture: 'Remove',
  resendCode: 'Resend code',
  sendCode: 'Send code',
  signup: 'Sign up',
  verifyCode: 'Verify code',
};

export default account;
